<template>
    <section>
        <!--工具条-->
        <!--<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;margin-bottom:22px;">
            <el-select v-model="SelStatus" filterable placeholder="请选择优惠券状态" style="width: 110px">
                <el-option label="全部" value="-1"></el-option>
                <el-option label="开启" value="0"></el-option>
                <el-option label="关闭" value="1"></el-option>
            </el-select>
            <el-input v-model="searchVal" placeholder="优惠券名称" style="width:300px;margin-left:10px;"></el-input>
            <el-button type="primary" @click="handleSearch()">查询</el-button>
            <el-button type="primary" @click="handleAdd()" v-if="isAdd">新增</el-button>
        </el-col>


        <!--列表-->
        <el-table :data="datas"
                  highlight-current-row
                  v-loading="listLoading"
                  @selection-change="selsChange"
                  @current-change="selectCurrentRow"
                  row-key="Id"
                  border
                  lazy
                  style="width: 99%;"
                  ref="table">
            <el-table-column type="index" :index="indexMethod" label="序号" width="50" fixed></el-table-column>
            <el-table-column prop="Name" label="名称" sortable width="150" fixed></el-table-column>
            <el-table-column prop="SpendAmount" label="满金额" width="90" sortable></el-table-column>
            <el-table-column prop="GetOffAmount" label="减金额" width="90" sortable></el-table-column>
            <el-table-column prop="TotalQuantity" label="总数量" width="90" sortable></el-table-column>
            <el-table-column prop="LimitedPerUser" label="限领数量" width="120" sortable></el-table-column>
            <el-table-column label="有效期类型" width="120" sortable>
                <template scope="scope">
                    {{scope.row.ValidityType==0?'固定期限':'相对期限'}}
                </template>
            </el-table-column>
            <el-table-column label="有效期" width="200" sortable>
                <template scope="scope">
                    <span v-if="scope.row.ValidityType==0">{{scope.row.ValidityStartTime|filterDate}}--{{scope.row.ValidityEndTime|filterDate}}</span>
                    <span v-if="scope.row.ValidityType==1">{{scope.row.ValidityDays}}天{{scope.row.ValidityHours}}小时</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="100" sortable>
                <template scope="scope">
                    {{scope.row.Status==0?'开启':'关闭'}}
                </template>
            </el-table-column>
            <el-table-column prop="CreationTime" label="添加日期" :formatter="formatCreateTime" width="120" sortable></el-table-column>
            <!--<el-table-column prop="Creatior" label="添加人" width="100" sortable></el-table-column>-->
            <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)" v-if="isEdit">编辑</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)" v-if="isDelete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
            <el-pagination layout="prev, pager, next"
                           @current-change="handleCurrentChange"
                           :page-size="50"
                           :total="total"
                           style="float:right;"></el-pagination>
        </el-col>
        <!--编辑界面-->
        <el-dialog title="编辑"
                   :visible.sync="editFormVisible"
                   v-model="editFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editForm" label-width="180px" :rules="editFormRules" ref="editForm">

                <el-form-item label="名称" prop="Name">
                    <el-input v-model="editForm.Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="满金额" prop="SpendAmount">
                    <el-input-number v-model="editForm.SpendAmount" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="减金额" prop="GetOffAmount">
                    <el-input-number v-model="editForm.GetOffAmount" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="总数量" prop="TotalQuantity">
                    <el-input-number v-model="editForm.TotalQuantity" :min="0"></el-input-number>（0表示不限数量）
                </el-form-item>
                <el-form-item label="每人限领数量" prop="LimitedPerUser">
                    <el-input-number v-model="editForm.LimitedPerUser" :min="0"></el-input-number>（0表示不限数量）
                </el-form-item>
                <el-form-item label="排序序号" prop="OrderNumber">
                    <el-input-number v-model="editForm.OrderNumber" :min="0"></el-input-number>（越大显示越靠前）
                </el-form-item>
                <el-form-item label="优惠券说明" prop="Instructions">
                    <el-input type="textarea" placeholder="优惠券说明" v-model="editForm.Instructions"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="Status">
                    <el-radio-group v-model="editForm.Status">
                        <el-radio class="radio" :label="0">开启</el-radio>
                        <el-radio class="radio" :label="1">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="有效期限类型" prop="ValidityType">
                    <el-radio-group v-model="editForm.ValidityType" @change="handleValidityType">
                        <el-radio class="radio" :label="0">固定期限</el-radio>
                        <el-radio class="radio" :label="1">相对期限</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    （相对期限表示从领取以后开始计算期限）
                </el-form-item>
                <el-form-item label="有效期开始" prop="ValidityStartTime" v-if="SelValidityType==0">
                    <el-date-picker type="date" placeholder="选择日期" v-model="editForm.ValidityStartTime"></el-date-picker>
                </el-form-item>
                <el-form-item label="有效期结束" prop="ValidityEndTime" v-if="SelValidityType==0">
                    <el-date-picker type="date" placeholder="选择日期" v-model="editForm.ValidityEndTime"></el-date-picker>
                </el-form-item>
                <el-form-item label="有效天数" prop="ValidityDays" v-if="SelValidityType==1">
                    <el-input-number v-model="editForm.ValidityDays" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="有效小时数" prop="ValidityHours" v-if="SelValidityType==1">
                    <el-input-number v-model="editForm.ValidityHours" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item v-if="SelValidityType==1">
                    （设置后，领取的优惠券将在领取时间上增加有效时间）
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>


        <!--新增界面-->
        <el-dialog title="新增"
                   :visible.sync="addFormVisible"
                   v-model="addFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="addForm"
                     label-width="100px"
                     :rules="addFormRules"
                     ref="addForm">




                <el-form-item label="名称" prop="Name">
                    <el-input v-model="addForm.Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="满金额" prop="SpendAmount">
                    <el-input-number v-model="addForm.SpendAmount" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="减金额" prop="GetOffAmount">
                    <el-input-number v-model="addForm.GetOffAmount" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="总数量" prop="TotalQuantity">
                    <el-input-number v-model="addForm.TotalQuantity" :min="0"></el-input-number>（0表示不限数量）
                </el-form-item>
                <el-form-item label="每人限领数量" prop="LimitedPerUser">
                    <el-input-number v-model="addForm.LimitedPerUser" :min="0"></el-input-number>（0表示不限数量）
                </el-form-item>
                <el-form-item label="排序序号" prop="OrderNumber">
                    <el-input-number v-model="addForm.OrderNumber" :min="0"></el-input-number>（越大显示越靠前）
                </el-form-item>
                <el-form-item label="优惠券说明" prop="Instructions">
                    <el-input type="textarea" placeholder="优惠券说明" v-model="addForm.Instructions"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="Status">
                    <el-radio-group v-model="addForm.Status">
                        <el-radio class="radio" :label="0">开启</el-radio>
                        <el-radio class="radio" :label="1">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="有效期限类型" prop="ValidityType">
                    <el-radio-group v-model="addForm.ValidityType" @change="handleValidityType">
                        <el-radio class="radio" :label="0">固定期限</el-radio>
                        <el-radio class="radio" :label="1">相对期限</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    （相对期限表示从领取以后开始计算期限）
                </el-form-item>
                <el-form-item label="有效期开始" prop="ValidityStartTime" v-if="SelValidityType==0">
                    <el-date-picker type="date" placeholder="选择日期" v-model="addForm.ValidityStartTime"></el-date-picker>
                </el-form-item>
                <el-form-item label="有效期结束" prop="ValidityEndTime" v-if="SelValidityType==0">
                    <el-date-picker type="date" placeholder="选择日期" v-model="addForm.ValidityEndTime"></el-date-picker>
                </el-form-item>
                <el-form-item label="有效天数" prop="ValidityDays" v-if="SelValidityType==1">
                    <el-input-number v-model="addForm.ValidityDays" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="有效小时数" prop="ValidityHours" v-if="SelValidityType==1">
                    <el-input-number v-model="addForm.ValidityHours" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item v-if="SelValidityType==1">
                    （设置后，领取的优惠券将在领取时间上增加有效时间）
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="addSubmit"
                           :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

    </section>
</template>

<script>
    import util from "../../../util/date";
    import { getPageCoupon, editCoupon, addCoupon, removeCoupon } from "../../api/api";
    import { getButtonList } from "../../promissionRouter";
    /* import Toolbar from "../../components/Toolbar2";*/
   /* import global_ from '../../components/Global'//引用全局模块*/

    export default {
        /*  components: { Toolbar },*/
        data() {
            return {
                filters: {
                    name: ""
                },
                searchVal: "",
                SelStatus: "-1",
                buttonList: [],
                datas: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [], //列表选中列
                currentRow: null,
                addDialogFormVisible: false,
                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
                    Instructions: [{ required: true, message: "请输入说明", trigger: "blur" }],
                    Status: [{ required: true, message: "请选择状态", trigger: "blur" }]
                },
                //编辑界面数据
                editForm: {
                    Id: 0,
                    Name: '',
                    SpendAmount: 0,
                    GetOffAmount: 0,
                    Instructions: '',
                    Status: 0,
                    TotalQuantity: 0,
                    OrderNumber: 0,
                    LimitedPerUser: 0,
                    ValidityType: 0,
                    ValidityDays: 0,
                    ValidityHours: 0,
                    ValidityStartTime: '',
                    ValidityEndTime: ''
                },

                addFormVisible: false, //新增界面是否显示
                addLoading: false,
                addFormRules: {
                    Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
                    Instructions: [{ required: true, message: "请输入说明", trigger: "blur" }],
                    Status: [{ required: true, message: "请选择状态", trigger: "blur" }]
                },
                //新增界面数据
                addForm: {
                    Id: 0,
                    Name: '',
                    SpendAmount: 0,
                    GetOffAmount: 0,
                    Instructions: '',
                    Status: 0,
                    TotalQuantity: 0,
                    OrderNumber: 0,
                    LimitedPerUser: 0,
                    ValidityType: 0,
                    ValidityDays: 0,
                    ValidityHours: 0,
                    ValidityStartTime: '',
                    ValidityEndTime: ''
                },
              
                isEdit: false,
                isDelete: false,
                isAdd: false,

                SelValidityType: 0,
            };
        },
        filters: {
            filterDate: function (value) {
                return !value || value == ""
                    ? ""
                    : util.formatDate.format(new Date(value), "yyyy-MM-dd");
            }
        },
        methods: {
            indexMethod(index) {
                index = (index + 1) + (this.page - 1) * 20;
                //index = this.total - (this.page - 1) * 20 - index
                return index;
            },
            selectCurrentRow(val) {
                this.currentRow = val;
            },
            callFunction(item) {
                this.filters = {
                    name: item.search
                };
                this[item.Func].apply(this, item);
            },

            handleValidityType(value) {
                this.SelValidityType = 0;
                if (value == "1" || value == 1) {
                    this.SelValidityType = 1;
                }
            },
            formatCreateTime: function (row, column) {
                return !row.CreationTime || row.CreationTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.CreationTime), "yyyy-MM-dd");
            },
            handleCurrentChange(val) {
                this.page = val;
                this.handleQuery();
            },
            handleSearch() {
                this.page = 1;
                this.handleQuery();
            },
            //获取用户列表
            handleQuery() {
                //let _this = this;
                let para = {
                    Status: this.SelStatus,
                    page: this.page,
                    key: this.searchVal
                };
                this.listLoading = true;
                //NProgress.start();
                getPageCoupon(para).then(res => {
                    this.total = res.data.response.dataCount;
                    this.datas = res.data.response.data;
                    this.listLoading = false;

                    console.log("total=" + this.total);

                    //NProgress.done();
                });
            },
            ////删除
            handleDel(index, cRow) {
                this.currentRow = cRow;
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error"
                    });

                    return;
                }
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        this.listLoading = true;
                        //NProgress.start();
                        let para = { id: row.Id };
                        removeCoupon(para).then(res => {
                            if (util.isEmt.format(res)) {
                                this.listLoading = false;
                                return;
                            }
                            this.listLoading = false;
                            //NProgress.done();
                            if (res.data.success) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error"
                                });
                            }

                            this.handleQuery();
                        });
                    })
                    .catch(() => { });
            },
            //显示编辑界面
            handleEdit(index, cRow) {

                this.baseInfos = [];

                this.currentRow = cRow;
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error"
                    });
                    return;
                }

                let that = this;

                this.editForm = {};
                that.editLoading = true;
                that.editFormVisible = true;

                that.editForm = Object.assign({}, row);
                this.SelValidityType = row.ValidityType;

                that.editLoading = false;

            },
            //显示新增界面
            handleAdd() {
                this.addFormVisible = true;
                this.addLoading = true;
                this.addForm = {
                    Name: '',
                    SpendAmount: 0,
                    GetOffAmount: 0,
                    Instructions: '',
                    Status: 0,
                    TotalQuantity: 0,
                    OrderNumber: 0,
                    LimitedPerUser: 0,
                    ValidityType: 0,
                    ValidityDays: 0,
                    ValidityHours: 0,
                    ValidityStartTime: '',
                    ValidityEndTime: ''
                };
                this.addLoading = false;
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate(valid => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            //NProgress.start();

                            let para = Object.assign({}, this.editForm);
                            if (para.Name == null || para.Name == "") {
                                this.$message({
                                    message: "名称不能为空！",
                                    type: "error"
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.GetOffAmount == null || para.GetOffAmount<=0) {
                                this.$message({
                                    message: "减金额不能为空！",
                                    type: "error"
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.Instructions == null || para.Instructions == "") {
                                this.$message({
                                    message: "优惠券说明不能为空！",
                                    type: "error"
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.ValidityType == 1) {

                                if ((para.ValidityDays == null || para.ValidityDays <= 0) && (para.ValidityHours == null || para.ValidityHours <= 0)) {
                                    this.$message({
                                        message: "有效天数和小时不能为空！",
                                        type: "error"
                                    });
                                    this.editLoading = false;
                                    return;
                                }
                            } else {
                                if ((para.ValidityStartTime == null || para.ValidityStartTime == "") || (para.ValidityEndTime == null || para.ValidityEndTime=="")) {
                                    this.$message({
                                        message: "有效期不能为空！",
                                        type: "error"
                                    });
                                    this.editLoading = false;
                                    return;
                                }
                            }

                            editCoupon(para).then(res => {
                                if (util.isEmt.format(res)) {
                                    this.editLoading = false;
                                    return;
                                }

                                if (res.data.success) {
                                    this.editLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success"
                                    });
                                    this.$refs["editForm"].resetFields();
                                    this.editFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error"
                                    });
                                    this.editLoading = false;
                                }
                            });
                        });
                    }
                });
            },
            //新增
            addSubmit: function () {
                let _this = this;
                this.$refs.addForm.validate(valid => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.addLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.addForm);


                            if (para.Name == null || para.Name == "") {
                                this.$message({
                                    message: "名称不能为空！",
                                    type: "error"
                                });
                                this.addLoading = false;
                                return;
                            }
                            if (para.GetOffAmount == null || para.GetOffAmount <= 0) {
                                this.$message({
                                    message: "减金额不能为空！",
                                    type: "error"
                                });
                                this.addLoading = false;
                                return;
                            }
                            if (para.Instructions == null || para.Instructions == "") {
                                this.$message({
                                    message: "优惠券说明不能为空！",
                                    type: "error"
                                });
                                this.addLoading = false;
                                return;
                            }
                            if (para.ValidityType == 1) {

                                if ((para.ValidityDays == null || para.ValidityDays <= 0) && (para.ValidityHours == null || para.ValidityHours <= 0)) {
                                    this.$message({
                                        message: "有效天数和小时不能为空！",
                                        type: "error"
                                    });
                                    this.addLoading = false;
                                    return;
                                }
                            } else {
                                if ((para.ValidityStartTime == null || para.ValidityStartTime == "") || (para.ValidityEndTime == null || para.ValidityEndTime == "")) {
                                    this.$message({
                                        message: "有效期不能为空！",
                                        type: "error"
                                    });
                                    this.addLoading = false;
                                    return;
                                }
                            }
                            addCoupon(para).then(res => {
                                if (util.isEmt.format(res)) {
                                    this.addLoading = false;
                                    return;
                                }
                                if (res.data.success) {
                                    this.addLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success"
                                    });
                                    this.$refs["addForm"].resetFields();
                                    this.addFormVisible = false;
                                    this.isCarNoShow = true;
                                    this.handleQuery();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error"
                                    });
                                    this.addLoading = false;
                                }

                            });
                        });
                    }
                });
            },
            selsChange: function (sels) {
                this.sels = sels;
            },
            ////批量删除
            //batchRemove: function () {
            //    this.$message({
            //        message: "该功能未开放",
            //        type: "warning"
            //    });
            //},
            //getButtonList2(routers) {
            //    let _this = this;
            //    routers.forEach(element => {
            //        let path = this.$route.path.toLowerCase();
            //        if (element.path && element.path.toLowerCase() == path) {
            //            _this.buttonList = element.children;
            //            return;
            //        } else if (element.children) {
            //            _this.getButtonList(element.children);
            //        }
            //    });
            //}

        },
        mounted() {
            this.handleQuery();

            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            //第一种写法，每个页面都需要写方法，但是可以做特性化处理
            // this.getButtonList(routers);

            //第二种写法，封装到 permissionRouter.js 中
            this.buttonList = getButtonList(this.$route.path, routers);

            this.buttonList.forEach(item => {
                if (item.Func == "handleEdit") {
                    this.isEdit = true;
                }
                else if (item.Func == "handleDel") {
                    this.isDelete = true;
                }
                else if (item.Func == "handleAdd") {
                    this.isAdd = true;
                }
                //else if (item.Func == "handleExport") {
                //    this.isExport = true;
                //}
                //
            });
        }
    };
</script>

<style scoped>
</style>
